module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image5c"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "354",
      "src": "images/13.jpg",
      "width": "300"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check any of the following that are true.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1b"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" Someone else claimed you as a dependent on his or her income tax return, but you earned more than $5,150 this year.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1b"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" You are single, had a gross income of $8,450 or more, and are not anyone’s dependent.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1b"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" You are married, filing jointly, and you have a combined gross income of $16,900.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1b"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" You are married, filing separately, and earned $3,300 (or more) this year.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1b"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" You are head of household and earned $10,850 or more.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1b"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" You are self-employed and earned $400 or more.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1b"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "12",
      "src": "images/box.jpg",
      "width": "12"
    }
  }), _vm._v(" You are a widow or widower with dependent children and earned $13,600 or more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you checked "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("any one")]), _vm._v(" of these items, then guess what?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("You have to file an income tax return! Giddy-up!")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Annual income tax returns are due April 15, or the following business day if April 15 falls on a weekend or holiday. This means you must mail (not just drop in the box but actually have postmarked) or file your income taxes before midnight on the due date.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Tax forms and instructions are available by mid-January. You can pick up paper forms for free at some post offices and libraries, or download forms online at ")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.irs.gov",
      "target": "_blank"
    }
  }, [_vm._v("www.irs.gov")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Documents and records you need to keep for tax time")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Copies of all W-2 forms")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Copy of completed tax form from the previous year")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Receipts for charitable donations (gifts of money or material items to nonprofit organizations)")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Receipts for job-related expenses (like travel and meals)")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Child-care receipts")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Mortgage statements")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Medical bills")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Education expenses")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Moving expenses")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Uniform receipts")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Mileage for traveling to volunteer or military (National Guard or Reserves) jobs")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "sidebartit"
  }, [_vm._v("Oh, gross!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Your gross income is all the money you made "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("before")]), _vm._v(" your employer took out any taxes, other deductions, or allowances. All figures are based on your gross income.")]), _vm._v(" "), _c('p', {
    staticClass: "sidebartit"
  }, [_vm._v("Are you a dependent?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To be someone’s dependent, you must . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• be that person’s child, stepchild, foster child, sibling, or descendent")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• reside more than six months a year with that person")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• be under the age of nineteen, or if you are a full-time student, under the age of twenty-four")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• not provide for more than half of your living expenses.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Tax deductions")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("You can deduct some items and expenses from your taxes, but you have to keep paperwork documenting that the deductions are legitimate. To make filing taxes easier, create a folder marked “Taxes,” and file all the financial records and receipts you receive throughout the year into it. Depending on your circumstances, you may or may not be allowed to deduct anything from your tax bill, but at least this way you’ll have your records ready.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("For more info visit the following Web sites:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  })]), _c('p', {
    staticClass: "indenthanginga"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("• Internal Revenue Service (")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.irs.com",
      "target": "_blank"
    }
  }, [_vm._v("www.irs.gov")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• H&R Block ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.hrblock.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hrblock.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• Intuit, Inc. ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://turbotax.intuit.com",
      "target": "_blank"
    }
  }, [_vm._v("http://turbotax.intuit.com")]), _vm._v(")")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71a0bd9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch09.vue
// module id = 111
// module chunks = 0